// extracted by mini-css-extract-plugin
export default {"container":"ServiceDiscount_container__NpK9b"};